import React from 'react';
import { motion } from 'framer-motion';

function OfferingsSection() {
  const offeringsData = [
    {
      key: 'portfolio',
      title: "Portfolio Management",
      description: "Personalized investment strategies tailored to your goals and risk profile. Our expert portfolio managers construct diversified portfolios optimized for risk-adjusted returns across global markets.",
      icon: "briefcase",
      link: "/portfolio-management"
    },
    {
      key: 'financial',
      title: "Financial Planning",
      description: "Strategic planning to achieve your short and long-term financial objectives. Comprehensive financial roadmaps covering retirement planning, tax optimization, estate planning, and wealth preservation.",
      icon: "chart",
      link: "/financial-planning"
    },
    {
      key: 'risk',
      title: "Risk Management",
      description: "Comprehensive risk assessment and protection strategies for your assets. Advanced portfolio risk analytics, hedging strategies, insurance solutions, and downside protection tailored to your risk tolerance.",
      icon: "shield",
      link: "/risk-management"
    },
    {
      key: 'wealth',
      title: "Wealth Management",
      description: "Holistic wealth management services integrating investment management, financial planning, and family office services. Dedicated relationship managers providing white-glove service for high-net-worth individuals.",
      icon: "crown",
      link: "/wealth-management"
    }
  ];

  const renderIcon = (icon) => {
    const common = { width: 24, height: 24, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' };
    switch (icon) {
      case 'briefcase':
        return (
          <svg {...common}>
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
            <path d="M16 7V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v3" />
          </svg>
        );
      case 'chart':
        return (
          <svg {...common}>
            <path d="M3 3v18h18" />
            <path d="M18 17V9m-5 8V5M8 17v-5" />
          </svg>
        );
      case 'shield':
        return (
          <svg {...common}>
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
        );
      case 'crown':
        return (
          <svg {...common}>
            <path d="M2 12l3-3 3 3 4-6 4 6 3-3 3 3v8H2v-8z" />
            <path d="M2 20h20" />
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div
          data-aos="fade-up"
          data-aos-delay="100"
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-semibold text-gray-900 mb-4">We Offer Wealth Management Solutions</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto text-center">
            Comprehensive wealth management services designed to help you achieve your financial goals.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {offeringsData.map((offering, index) => (
            <a
              href={offering.link}
              key={offering.title}
              data-aos="fade-up"
              data-aos-delay={`${200 + index * 100}`}
              className="group bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 p-8 border border-gray-100 hover:border-[#0056d7] cursor-pointer"
            >
              <div className="w-16 h-16 rounded-full bg-[#0056d7] group-hover:bg-gradient-to-br group-hover:from-[#0056d7] group-hover:to-[#003d9e] flex items-center justify-center shadow-md mb-6 text-white transition-all duration-300">
                {renderIcon(offering.icon)}
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3 group-hover:text-[#0056d7] transition-colors">{offering.title}</h3>
              <p className="text-gray-600 leading-relaxed text-sm mb-4">{offering.description}</p>
              <div className="flex items-center gap-2 text-[#0056d7] font-semibold text-sm group-hover:gap-3 transition-all">
                Learn more
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14"/>
                  <path d="M12 5l7 7-7 7"/>
                </svg>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default OfferingsSection;
